// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.91.0-beta.2b7e10114',
  revision: '2b7e10114',
  branch: 'develop',
  date: 'Thu, 01 Oct 2026 13:23:51 GMT'
};